module.exports = __webpack_public_path__ + "static/media/03_BOJO_MEIA_TACA_LISO_01.2f96e8f6.jpg";